import * as React from 'react';

function SvgClearAll(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path d='M5 11h14v2H5zm-2 4h14v2H3zm4-8h14v2H7z' />
		</svg>
	);
}

export default SvgClearAll;
